import { FaClipboard, FaCog, FaCompass, FaReceipt } from "react-icons/fa";
import { IoIosBoat } from "react-icons/io";
import {
  MdAccountBalanceWallet,
  MdNavigateBefore,
  MdNavigateNext,
} from "react-icons/md";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import { IoLogOut } from "react-icons/io5";
import { IoMenu, IoPersonCircle } from "react-icons/io5";
import { routerPaths } from "../../services/path";
import { Link, useLocation } from "react-router-dom";
import Logo from "../common/Logo";
import { useState } from "react";
import AuthService from "../../services/authService";
import { useQueryClient } from "react-query";

function SideBar() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const [toggled, setToggled] = useState(false);
  const queryClient = useQueryClient();

  return (
    <div>
      <main
        style={{
          display: "flex",
          paddingLeft: 10,
          paddingRight: 10,
          paddingTop: 10,
        }}
      >
        <div>
          <IoMenu
            size={45}
            className="shadow-md rounded-full p-2 lg:hidden"
            onClick={() => {
              setToggled(!toggled);
              setCollapsed(toggled);
            }}
          />
        </div>
      </main>
      <Sidebar
        collapsed={collapsed}
        className="bg-white h-screen"
        onBackdropClick={() => setToggled(false)}
        toggled={toggled}
        breakPoint="lg"
      >
        <div className="flex justify-center items-center my-5 ">
          <Logo />
        </div>
        <div className="flex items-end justify-end ">
          <button className="hidden lg:block" onClick={toggleCollapsed}>
            {collapsed ? (
              <MdNavigateNext
                className="shadow-md rounded-full p-2"
                size={35}
              />
            ) : (
              <MdNavigateBefore
                className="shadow-md rounded-full p-2"
                size={35}
              />
            )}
          </button>
        </div>
        <Menu
          menuItemStyles={{
            button: {
              color: "#636161",
              [`&.ps-active`]: {
                color: "#000000",
              },
            },
          }}
        >
          <div className="h-20">
            <MenuItem
              active={location.pathname === routerPaths.dashboard}
              icon={<FaCompass size={28} />}
              component={<Link to={routerPaths.dashboard} />}
            >
              {" "}
              Overview
            </MenuItem>
          </div>
          <div className="h-20">
            <MenuItem
              active={location.pathname === routerPaths.booking}
              icon={<FaReceipt size={28} />}
              component={<Link to={routerPaths.booking} />}
            >
              {" "}
              Bookings
            </MenuItem>
          </div>
          <div className="h-20">
            <MenuItem
              active={location.pathname === routerPaths.hireHistory}
              icon={<FaClipboard size={28} />}
              component={<Link to={routerPaths.hireHistory} />}
            >
              {" "}
              Hire History
            </MenuItem>
          </div>
          <div className="h-20">
            <MenuItem
              active={
                location.pathname.split("/")[1] ===
                routerPaths.wallet.replace("/", "")
              }
              icon={<MdAccountBalanceWallet size={28} />}
              component={<Link to={routerPaths.wallet} />}
            >
              {" "}
              Wallet
            </MenuItem>
          </div>{" "}
          <div className="h-20">
            <MenuItem
              active={location.pathname === routerPaths.boat}
              icon={<IoIosBoat size={28} />}
              component={<Link to={routerPaths.boat} />}
            >
              Boats
            </MenuItem>
          </div>{" "}
          <div className="h-20">
            <MenuItem
              active={location.pathname === routerPaths.profile}
              icon={<IoPersonCircle size={28} />}
              component={<Link to={routerPaths.profile} />}
            >
              Profile
            </MenuItem>
          </div>{" "}
          <div className="h-20">
            <MenuItem
              active={location.pathname === routerPaths.settings}
              icon={<FaCog size={28} />}
              component={<Link to={routerPaths.settings} />}
            >
              Settings
            </MenuItem>
          </div>{" "}
          <div className="h-20 !text-red-600">
            <MenuItem
              onClick={() => {
                queryClient.removeQueries();
                AuthService.logOut();
                window.location.reload();
              }}
              icon={<IoLogOut color={"red"} size={30} />}
              component={<Link to={routerPaths.signIn} />}
              style={{ color: "red" }}
            >
              Log Out
            </MenuItem>
          </div>{" "}
        </Menu>
      </Sidebar>
    </div>
  );
}

export default SideBar;
